"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PerformanceMetrics = void 0;
var PerformanceMetrics = /** @class */function () {
  function PerformanceMetrics() {
    this.entries = [];
    this.MAX_TRIGGER_COUNT_FOR_AGGREGATED_LOGGING = 10;
    this.essErrorCount = 0;
    this.TRIGGER_TYPE_FOCUS = "focus";
    this.TRIGGER_TYPE_INPUT = "input";
    this.errorCodes = [];
    this.proxyRegion = "";
  }
  PerformanceMetrics.isStatusCodeInRange = function (statusCode, begin, end) {
    if (isNaN(statusCode)) {
      return false;
    }
    return begin <= statusCode && statusCode <= end;
  };
  PerformanceMetrics.prototype.logTypeaheadRequest = function (query) {
    var triggerType = query.trim().length === 0 ? this.TRIGGER_TYPE_FOCUS : this.TRIGGER_TYPE_INPUT;
    var request = {
      query: query,
      timestamp: Date.now(),
      triggerType: triggerType
    };
    this.entries.push({
      request: request,
      responseShown: false
    });
  };
  PerformanceMetrics.prototype.logResponse = function (response) {
    var _a;
    this.proxyRegion = ((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a.get("x-proxy-region")) || "";
  };
  PerformanceMetrics.prototype.logTypeaheadResponse = function (response) {
    if (response) {
      var query = response.q;
      var suggestionCount = response.sr ? response.sr.length : 0;
      var entry = this.getRequestMetricEntry(query);
      if (entry) {
        var responseTimestamp = Date.now();
        entry.response = {
          latency: responseTimestamp - entry.request.timestamp,
          query: query,
          suggestionCount: suggestionCount,
          timestamp: responseTimestamp
        };
      }
    }
  };
  PerformanceMetrics.prototype.logSuggestionShown = function (query) {
    var entry = this.getResponseMetricEntry(query);
    if (entry) {
      entry.responseShown = true;
    }
  };
  PerformanceMetrics.prototype.logError = function (statusCode, statusText) {
    if (!PerformanceMetrics.isStatusCodeInRange(statusCode, 200, 299)) {
      this.essErrorCount++;
    }
    this.errorCodes.push(statusCode);
  };
  PerformanceMetrics.prototype.getMetrics = function () {
    var _a;
    if (this.entries.length) {
      var metric = {};
      var entryCount = this.MAX_TRIGGER_COUNT_FOR_AGGREGATED_LOGGING < this.entries.length ? this.MAX_TRIGGER_COUNT_FOR_AGGREGATED_LOGGING : this.entries.length;
      for (var i = 0; i < entryCount; i++) {
        var entry = this.entries[i];
        if (entry.response) {
          // @ts-ignore
          metric["latency" + i] = entry.response.latency;
          if (i === 0) {
            metric.query0 = entry.response.query;
          }
        }
      }
      metric.latencyMedian = this.getMedianLatency();
      var worstLatencyMetric = this.getWorstLatencyMetric();
      metric.queryWorst = worstLatencyMetric ? worstLatencyMetric.response && worstLatencyMetric.response.query : undefined;
      metric.latencyWorst = worstLatencyMetric ? worstLatencyMetric.response && worstLatencyMetric.response.latency : undefined;
      var last = this.entries[this.entries.length - 1];
      metric.queryLast = last.request.query;
      metric.latencyLast = last.response ? last.response.latency : undefined;
      metric.totalTriggers = this.entries.length;
      metric.totalSuccess = this.getSuccessMetrics().length;
      metric.totalOnePlusCharTypeaheadShown = this.entries.filter(function (entry) {
        return entry.request.query && entry.responseShown;
      }).length;
      metric.onFocusTypeaheadShown = ((_a = this.getResponseMetricEntry("")) === null || _a === void 0 ? void 0 : _a.responseShown) || false;
      if (this.essErrorCount > 0) {
        metric.essErrorCount = this.essErrorCount;
      }
      if (this.errorCodes.length > 0) {
        metric.error = this.errorCodes.join(",");
      }
      metric.proxyRegion = this.proxyRegion;
      return metric;
    }
    return undefined;
  };
  PerformanceMetrics.prototype.getRequestMetricEntry = function (query) {
    var e_1, _a;
    try {
      for (var _b = __values(this.entries), _c = _b.next(); !_c.done; _c = _b.next()) {
        var entry = _c.value;
        if (entry.request.query === query && !entry.response) {
          return entry;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    return undefined;
  };
  PerformanceMetrics.prototype.getResponseMetricEntry = function (query) {
    var e_2, _a;
    try {
      for (var _b = __values(this.entries), _c = _b.next(); !_c.done; _c = _b.next()) {
        var entry = _c.value;
        if (entry.request.query === query && entry.response) {
          return entry;
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return undefined;
  };
  PerformanceMetrics.prototype.getWorstLatencyMetric = function () {
    var e_3, _a;
    var worstLatencyMetric;
    try {
      for (var _b = __values(this.entries), _c = _b.next(); !_c.done; _c = _b.next()) {
        var entry = _c.value;
        if (entry.response) {
          if (!worstLatencyMetric || worstLatencyMetric.response && worstLatencyMetric.response.latency < entry.response.latency) {
            worstLatencyMetric = entry;
          }
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
    return worstLatencyMetric;
  };
  PerformanceMetrics.prototype.latencySortFunction = function (a, b) {
    if (a.response && b.response) {
      return a.response.latency - b.response.latency;
    } else {
      return a.response ? -1 : b.response ? 1 : 0;
    }
  };
  PerformanceMetrics.prototype.getMedianLatency = function () {
    var medianLatency;
    var successMetrics = this.getSuccessMetrics();
    successMetrics.sort(this.latencySortFunction);
    if (successMetrics.length) {
      var mid = Math.floor(successMetrics.length / 2);
      // @ts-ignore
      var midLatency = successMetrics[mid].response.latency;
      if (successMetrics.length % 2) {
        medianLatency = midLatency;
      } else {
        // @ts-ignore
        var midMinusOneLatency = successMetrics[mid - 1].response.latency;
        medianLatency = (midMinusOneLatency + midLatency) / 2;
      }
    }
    return medianLatency;
  };
  PerformanceMetrics.prototype.getSuccessMetrics = function () {
    return this.entries.filter(function (entry) {
      return entry.response;
    });
  };
  return PerformanceMetrics;
}();
exports.PerformanceMetrics = PerformanceMetrics;